<template>
    <div>
        <div class="mb-3">
            <BackButton :to="__('navigation.invitations')"/>
        </div>

        <div class="wizard wizard-4 mt-4" data-wizard-state="first">
            <UserInviteWizardNavigation v-model="page"/>

            <div class="card card-custom card-shadowless rounded-top-0">
                <div class="card-body p-0">
                    <div class="row justify-content-center py-8 px-8 py-lg-15 px-lg-10">
                        <div class="col-xl-12 col-xxl-7">
                            <div class="form mt-0 mt-lg-10 fv-plugins-bootstrap fv-plugins-framework">
                                <!-- STEP 1 -->
                                <UserDetails v-show="page === 1"
                                             v-model="formData.user"
                                             :roles="roles"
                                />

                                <!-- STEP 2 -->
                                <AgencyDetails v-show="page === 2"
                                               v-model="formData.agency"
                                               :agencies="agencies"
                                />

                                <!-- STEP 3 -->
                                <StoreDetails v-show="page === 3"
                                              v-model="formData.store"
                                />

                                <!-- STEP 4 -->
                                <Overview v-show="page === 4"
                                          :form-data="formData"
                                />

                                <!-- WIZARD ACTIONS -->
                                <Actions v-model="page" @submit="submitInvitation"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {PermissionsMixin} from '@js/permissions'
import SelectAgency from "@components/Agency/SelectAgency.vue";
import AssociateStore from "@components/Invitation/AssociateStore.vue";
import BackButton from "@components/BackButton.vue";
import IconUser from "@components/Icons/Keen/IconUser.vue";
import IconBoxes from "@components/Icons/Keen/IconBoxes.vue";
import IconDoors from "@components/Icons/Keen/IconDoors.vue";
import IconChecks from "@components/Icons/Keen/IconChecks.vue";
import UserDetails from "./Wizard/UserDetails.vue";
import UserInviteWizardNavigation from "./Wizard/UserInviteWizardNavigation.vue";
import AgencyDetails from "./Wizard/AgencyDetails.vue";
import StoreDetails from "./Wizard/StoreDetails.vue";
import Overview from "./Wizard/Overview.vue";
import Actions from "./Wizard/Actions.vue";

export default {
    mixins: [PermissionsMixin],

    components: {
        Actions,
        Overview,
        StoreDetails,
        AgencyDetails,
        UserInviteWizardNavigation,
        UserDetails,
        IconChecks,
        IconDoors,
        IconBoxes,
        IconUser,
        BackButton,
        SelectAgency,
        AssociateStore,
        Multiselect,
    },

    props: {
        roles: Array,
        agencies: Array,
        old: Object,
    },

    data() {
        return {
            page: 1,
            pages: 4,
            formData: {
                agency: {},
                store: {},
                user: {
                    email: null,
                    phone: null,
                    role: {
                        name: this.__('roles.customer'),
                        value: 'customer'
                    }
                }
            }
        }
    },

    methods: {
        submitInvitation(){
            this.$inertia.post(this.$route('users.invitations.create'), this.formData);
        }
    }
}
</script>

<style>
@media only screen and (min-width: 1400px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
        width: calc(25% - .5rem) !important;
        flex: 0 0 calc(25% - .5rem);
    }
}
</style>
